import React, { useState } from 'react'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { Form, Button, Container } from 'react-bootstrap'
import firebaseConfig from '../../../Utilities/Firebase'
import Navbars from '../../../Components/Navbar'
import LoadingSpinner from '../../../Components/LoadingSpinner'
import { initializeApp } from 'firebase/app'
import { useNavigate } from 'react-router'
function Login() {
  const [Email, setEmail] = useState('')
  const [Password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const FirebaseApp = initializeApp(firebaseConfig)
  const navigate = useNavigate()
  var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  function Signin() {
    if (mailformat.test(Email) === false && Password.length <= 0) {
      setError(true)
    } else {
      setIsLoading(true)
      const auth = getAuth(FirebaseApp)
      signInWithEmailAndPassword(auth, Email, Password)
        .then(userCredential => {
          setIsLoading(false)
          navigate('/home')
        })
        .catch(error => {
          setIsLoading(false)
          setError(true)
          console.log(error)
        })
    }
  }

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      <Navbars type={'0'} />
      <br />
      <br />
      <br />
      <center>
        <Container
          style={{
            backgroundColor: 'whitesmoke',
            width: '40%',
            border: '1px black solid',
          }}
        >
          <Form>
            <br />
            <br />
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                onInput={event => {
                  setError(false)
                  setEmail(event.target.value)
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                onInput={event => {
                  setError(false)
                  setPassword(event.target.value)
                }}
              />
            </Form.Group>
            {error ? <label style={{ color: 'red' }}>Cannot login</label> : null}
            <br />
            <Button
              variant="success"
              onClick={() => {
                Signin()
              }}
            >
              Submit
            </Button>
            <br />
            <br />
          </Form>
        </Container>
      </center>
    </div>
  )
}
export default Login
